import React from 'react';
import { useTranslation } from 'react-i18next';
import { NotificationStatus } from '@cp-shared-19/frontend-ui';
import { Notification } from '@vwfs-bronson/bronson-react';

export type ErrorNotificationProps = {
    testId: string;
    headline?: string;
    text?: string;
    className?: string;
};

export const ErrorNotification: React.FC<ErrorNotificationProps> = ({ testId, headline, text, className }) => {
    const { t } = useTranslation();

    const headlineText = headline;
    let errorText = text;

    if (!text) {
        errorText = t('error.no-connection.text');
    }

    return (
        <Notification
            status={NotificationStatus.error}
            title={headlineText ?? ''}
            hideTitle={!headlineText}
            testId={testId}
            className={className}
            visible
            showCloseButton={false}
        >
            {errorText}
        </Notification>
    );
};
